import { ProcessGeneral } from 'api/endpoints/processes';
import {
  ScanConfigurationGeneral,
  UpdateScanConfig,
} from 'api/endpoints/processScan';
import { ApiResponseAsync } from 'container/models';
import { ProcessDraftOrRelease } from 'types/processDraftOrRelease';

export type ScanScenario = ScanConfigurationGeneral;

export const CONFIG_STOP_PATHS = ['mapper.dataMap', 'mapper.params'];

export interface IScanScenarioRepo {
  getScanScenario(
    process: ProcessDraftOrRelease,
    scanScenarioId: string
  ): ApiResponseAsync<ScanScenario>;

  getAllScanScenarios(
    process: ProcessDraftOrRelease
  ): ApiResponseAsync<DataWithTotal<ScanConfigurationGeneral>>;

  createScanScenario(
    process: ProcessGeneral,
    params: UpdateScanConfig
  ): ApiResponseAsync<ScanConfigurationGeneral>;

  updateScanScenario(
    process: ProcessGeneral,
    scenario: ScanConfigurationGeneral,
    params: UpdateScanConfig
  ): ApiResponseAsync<ScanConfigurationGeneral>;

  deleteScanScenario(
    process: ProcessGeneral,
    scenario: ScanConfigurationGeneral
  ): ApiResponseAsync<unknown>;
}
